import React from 'react';
import { useFilteredParticipants } from '../../../../../data/hooks/participant/useFilteredParticipants';
import { useRecommendedParticipantsFilter } from '../../../../../data/hooks/participant/useRecommendedParticipantsFilter';
import { AlphabeticalParticipantsList } from '../../../../elements/ParticipantsList';
import EmptyParticipantsListMessage from '../EmptyParticipantsListMessage';

function FilteredParticipantsList(props) {
    const {className = '', eventId} = props,
        [filteredParticipants, filterParams, filtering] = useFilteredParticipants(eventId, null, {
            connections: !!filterParams?.connections,
            meetings: false,
            qa: false,
        }),
        suggestedFilterParams = useRecommendedParticipantsFilter(eventId);

    if (!filteredParticipants.length && !filtering) {
        return <EmptyParticipantsListMessage filterParams={filterParams} suggestedFilterParams={suggestedFilterParams} />;
    }

    return (
        <AlphabeticalParticipantsList
            className={className}
            eventId={eventId}
            participants={filteredParticipants}
            savePosition={'eventParticipants-' + eventId}
            busy={filtering}
        />
    );
}

export default FilteredParticipantsList;
